import { formatISO } from "date-fns";
import { NextRouter } from "next/router";
import * as Sentry from "@sentry/nextjs";

import { createSuperPropertiesForTrackingEvent } from "utils/mixpanel/mixpanel-utils";
import {
  ITrackNPSEventArguments,
  ITrackNPSEventpayload,
  NPSTrackingSource
} from "./nps-mixpanel-utils.types";

const formatDateForNpsTrackingEvent = (start_date: string | undefined) => {
  try {
    return start_date ? formatISO(new Date(start_date)) : null;
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
};
export const createPayloadForNPSTrackingEvent = (
  args: ITrackNPSEventArguments
): ITrackNPSEventpayload => {
  const {
    classStartTime,
    classTopic,
    classSubject,
    trialClassId,
    source,
    npsRating,
    parentNumber,
    feedback,
    useAuthData: { userData }
  } = args;
  const payload = createSuperPropertiesForTrackingEvent(args);
  payload["User ID"] = userData.primary_user.id;
  payload["Class Start time"] =
    formatDateForNpsTrackingEvent(classStartTime) || null;
  payload["Class Topic"] = classTopic || null;
  payload["Class Subject"] = classSubject || null;
  payload["Trial Class ID"] = trialClassId || null;
  payload["NPS Source"] = source || null;
  if (npsRating || npsRating === "") payload["NPS rating"] = npsRating || "";
  if (feedback || feedback === "") payload["Feedback text"] = feedback || "";
  if (parentNumber || parentNumber === "")
    payload[`Parent's Number`] = parentNumber || "";
  return payload;
};

export const getNPSSource = (router: NextRouter): NPSTrackingSource => {
  const { live_class_id } = router.query;
  if (live_class_id) return NPSTrackingSource.FEEDBACK_LINK;
  return NPSTrackingSource.APP_RELAUNCH;
};
